import { FieldArray } from "formik";
import {
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
  Label,
  FormGroup,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import SelectField from "../../Utils/SelectField";
import InputField from "../../Utils/InputField";
import { LabelText } from "../../Utils/Input";
import { Link } from "react-router-dom";
import { removeRowsFromGrantsAndCharges } from "./constants/checkEmptyFields";
import {
  grantsAndChargesHandle,
  handleGrantsAndChargesRecurringFrequencyAndUsageOptions,
  handleGrantsAndChargesResourceValueAndUsageFields,
  handleInfiniteForGrantsAndCharges,
} from "./constants/GrantsAndRecurringFunctions";
import {
  chargesTabChange,
  handleChargesRecurringOverride,
} from "./constants/displayInfinite";
import { CycleAlignmentOption } from "./constants/initialValues";
import { useContext } from "react";
import { CreateOfferContext } from "./context";
import { handleRadioChargeTypeChange } from "../../Customers/constants/HandleChangeFunctions";
import { CreatableSelectField } from "../../Utils/CreatableSelectField";

export default function ChargesRecurring({ pushRef }) {
  const {
    values,
    errors,
    isEdit,
    isSubscribed,
    stateCharges,
    resourceData,
    recurringFrequencyOptions,
    touched,
    setTouched,
    handleChange,
    handleChargesProrateState,
    overrideChargeRecurring,
    chargeResourceOptions,
    setFieldValue,
    setFieldTouched,
    infiniteOptions,
    isEmptyorInvalidFieldForGrantsAndCharges,
    sectionRefs,
    chargesActiveTab,
    setChargesActiveTab,
    serviceBarringState,
  } = useContext(CreateOfferContext);

  const handleCloneCharge = (index, push) => {
    if (values.recurringCharges && values.recurringCharges[index]) {
      const clonedCharge = JSON.parse(
        JSON.stringify(values.recurringCharges[index])
      );
      push(clonedCharge);
    }
  };

  return (
    <FieldArray name="recurringCharges">
      {({ push, remove }) => {
        pushRef.current = push;
        return (
          <div className="live-preview">
            {values?.recurringCharges?.map((val, index) => {
              const keyIndex = values?.recurringCharges?.length - (index + 1);
              const chargeRef =
                sectionRefs.current[`recurringCharges${keyIndex + 1}`];
              return (
                <div
                  key={keyIndex}
                  className="border border-opacity-50 rounded-0 mb-3"
                  ref={chargeRef}
                >
                  <Row className="mb-0 px-3 pt-3">
                    <Col
                      xs={12}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <h3 className="card-title mb-0">
                        Charge {keyIndex > 0 ? keyIndex + 1 : ""}
                      </h3>
                      <div className="d-flex ms-auto me-5 mt-1">
                        <div className="me-4" id={`one-time-${keyIndex}`}>
                          <Input
                            type="radio"
                            name={`recurringCharges[${keyIndex}].type`}
                            className="me-2"
                            checked={
                              values?.recurringCharges[keyIndex]?.type === "1"
                            }
                            onChange={handleRadioChargeTypeChange(
                              "1",
                              setFieldValue,
                              `recurringCharges[${keyIndex}].type`
                            )}
                            disabled={isSubscribed || serviceBarringState}
                          />
                          {/* <OneTimeIcon /> */}
                          <LabelText
                            displayText={"One Time"}
                            classLabelName={"ms-2"}
                          />
                        </div>
                        {serviceBarringState && (
                          <UncontrolledTooltip target={`one-time-${keyIndex}`}>
                            {" "}
                            Service Barring is applicable only for Recurring
                            charges.
                          </UncontrolledTooltip>
                        )}
                        <div className="me-2">
                          <Input
                            type="radio"
                            name={`recurringCharges[${keyIndex}].type`}
                            className="mx-2"
                            checked={
                              values?.recurringCharges[keyIndex]?.type === "2"
                            }
                            onChange={handleRadioChargeTypeChange(
                              "2",
                              setFieldValue,
                              `recurringCharges[${keyIndex}].type`
                            )}
                            disabled={isSubscribed}
                          />
                          {/* <RecurringIcon /> */}
                          <LabelText
                            displayText={"Recurring"}
                            classLabelName={"ms-2"}
                          />
                        </div>
                      </div>
                      {!isSubscribed && (
                        <div>
                          {/* <Link
                            to="#"
                            className="link-primary me-2"
                            onClick={() => {
                              !isEmptyorInvalidFieldForGrantsAndCharges(
                                keyIndex,
                                values.recurringCharges
                              ) && handleCloneCharge(keyIndex, push);
                            }}
                          >
                            <i
                              data-testid="clone"
                              className="ri-file-copy-line"
                            ></i>
                          </Link> */}
                          <Link
                            to="#"
                            className="link-danger"
                            onClick={() => {
                              remove(keyIndex);
                              keyIndex === 0 &&
                                chargesTabChange(
                                  "1",
                                  chargesActiveTab,
                                  setChargesActiveTab
                                );
                            }}
                          >
                            <i
                              data-testid="delete"
                              className="ri-delete-bin-5-line"
                            ></i>
                          </Link>
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3 px-3 pt-3">
                    {values?.recurringCharges?.[keyIndex]?.type === "2" && (
                      <>
                        <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                          <Label>
                            Recurring Frequency
                            <span className="text-danger"> *</span>
                          </Label>
                          <LabelText
                            htmlFor={`recurringCharges[${keyIndex}].recurringFrequency`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              (touched?.recurringCharges &&
                                touched?.recurringCharges?.[keyIndex] &&
                                !values?.recurringCharges?.[keyIndex]
                                  .recurringFrequency) ||
                              false
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.recurringCharges?.[keyIndex]
                                ?.recurringFrequency &&
                              errors?.recurringCharges?.[keyIndex]
                                ?.recurringFrequency
                                ? errors?.recurringCharges?.[keyIndex]
                                    ?.recurringFrequency
                                : "Select Recurring Frequency"
                            }
                          />
                          <SelectField
                            name={`recurringCharges[${keyIndex}].recurringFrequency`}
                            placeholder={" "}
                            value={
                              values?.recurringCharges?.[keyIndex]
                                .recurringFrequency
                            }
                            isDisabled={isSubscribed}
                            handleChange={handleGrantsAndChargesRecurringFrequencyAndUsageOptions(
                              values.recurringCharges?.[keyIndex]
                                .recurringFrequency,
                              `recurringCharges[${keyIndex}].recurringFrequency`,
                              setFieldValue,
                              setFieldTouched
                            )}
                            // defaultValue={recurringFrequencyOptions[0]}
                            options={recurringFrequencyOptions}
                            isRVStyle={true}
                          />
                        </Col>
                        <Col xs={12} md={6} lg={6} xxl={3} className="mb-3">
                          <Label
                            for={`recurringCharges[${keyIndex}].recurringFrequencyUnit`}
                          >
                            Recurring Frequency Unit
                            <span className="text-danger"> *</span>
                          </Label>
                          <LabelText
                            htmlFor={`recurringCharges[${keyIndex}].recurringFrequencyUnit`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              (touched?.recurringCharges &&
                                touched?.recurringCharges?.[keyIndex] &&
                                !values?.recurringCharges?.[keyIndex]
                                  .recurringFrequencyUnit) ||
                              false
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.recurringCharges?.[keyIndex]
                                ?.recurringFrequencyUnit &&
                              errors?.recurringCharges?.[keyIndex]
                                ?.recurringFrequencyUnit
                                ? errors?.recurringCharges?.[keyIndex]
                                    ?.recurringFrequencyUnit
                                : "Enter Recurring Frequency Unit"
                            }
                          />
                          <InputField
                            name={`recurringCharges[${keyIndex}].recurringFrequencyUnit`}
                            className={"form-control"}
                            type="number"
                            handleChange={handleGrantsAndChargesResourceValueAndUsageFields(
                              handleChange
                            )}
                            value={
                              values.recurringCharges?.[keyIndex]
                                .recurringFrequencyUnit
                            }
                            invalid={
                              errors.recurringCharges &&
                              errors.recurringCharges?.[keyIndex] &&
                              touched.recurringCharges &&
                              touched.recurringCharges?.[keyIndex] &&
                              touched.recurringCharges?.[keyIndex]
                                .recurringFrequencyUnit &&
                              errors.recurringCharges?.[keyIndex]
                                .recurringFrequencyUnit
                                ? true
                                : false
                            }
                          />
                        </Col>
                        <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                          <Label>
                            Cycle Alignment
                            <span className="text-danger"> *</span>
                          </Label>
                          <LabelText
                            htmlFor={`recurringCharges[${keyIndex}].cycleAlignment`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              (touched?.recurringCharges &&
                                touched?.recurringCharges?.[keyIndex] &&
                                !values?.recurringCharges?.[keyIndex]
                                  .cycleAlignment) ||
                              false
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.recurringCharges?.[keyIndex]
                                ?.cycleAlignment &&
                              errors?.recurringCharges?.[keyIndex]
                                ?.cycleAlignment
                                ? errors?.recurringCharges?.[keyIndex]
                                    ?.cycleAlignment
                                : "Select Cycle Alignment"
                            }
                          />
                          <SelectField
                            name={`recurringCharges[${keyIndex}].cycleAlignment`}
                            placeholder={" "}
                            isDisabled={isSubscribed}
                            value={
                              values?.recurringCharges?.[keyIndex]
                                .cycleAlignment
                            }
                            // defaultValue={CycleAlignmentOption[1]}
                            handleChange={handleGrantsAndChargesRecurringFrequencyAndUsageOptions(
                              values.recurringCharges?.[keyIndex]
                                .cycleAlignment,
                              `recurringCharges[${keyIndex}].cycleAlignment`,
                              setFieldValue,
                              setFieldTouched
                            )}
                            options={CycleAlignmentOption}
                            isRVStyle={true}
                          />
                        </Col>
                      </>
                    )}
                    <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                      <Label for={`recurringCharges[${keyIndex}].resourceType`}>
                        Resource Type<span className="text-danger"> *</span>
                      </Label>
                      <LabelText
                        htmlFor={`recurringCharges[${keyIndex}].resourceType`}
                        classLabelName={`d-block ms-0 rv-sub-label ${
                          (touched?.recurringCharges &&
                            touched?.recurringCharges?.[keyIndex] &&
                            !values?.recurringCharges?.[keyIndex]
                              .resourceType) ||
                          false
                            ? "rv-label-danger"
                            : "rv-label-muted"
                        } `}
                        displayText={
                          touched?.recurringCharges?.[keyIndex]?.resourceType &&
                          errors?.recurringCharges?.[keyIndex]?.resourceType
                            ? errors?.recurringCharges?.[keyIndex]?.resourceType
                            : "Select Resource Type"
                        }
                      />
                      <SelectField
                        className={
                          (touched.recurringCharges &&
                            touched.recurringCharges?.[keyIndex] &&
                            !values.recurringCharges?.[keyIndex]
                              .resourceType) ||
                          false
                            ? "error-input"
                            : ""
                        }
                        name={`recurringCharges[${keyIndex}].resourceType`}
                        placeholder={" "}
                        isDisabled={isSubscribed}
                        value={values.recurringCharges?.[keyIndex].resourceType}
                        handleChange={grantsAndChargesHandle(
                          `recurringCharges[${keyIndex}].resourceType`,
                          values.recurringCharges?.[keyIndex],
                          setFieldValue,
                          setFieldTouched,
                          resourceData
                        )}
                        options={chargeResourceOptions}
                        isRVStyle={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                      <Label
                        for={`recurringCharges[${keyIndex}].resourceValue`}
                      >
                        Resource Value<span className="text-danger"> *</span>
                      </Label>
                      <LabelText
                        htmlFor={`recurringCharges[${keyIndex}].resourceValue`}
                        classLabelName={`d-block ms-0 rv-sub-label ${
                          (touched?.recurringCharges &&
                            touched?.recurringCharges?.[keyIndex] &&
                            !values?.recurringCharges?.[keyIndex]
                              .resourceValue) ||
                          false
                            ? "rv-label-danger"
                            : "rv-label-muted"
                        } `}
                        displayText={
                          touched?.recurringCharges?.[keyIndex]
                            ?.resourceValue &&
                          errors?.recurringCharges?.[keyIndex]?.resourceValue
                            ? errors?.recurringCharges?.[keyIndex]
                                ?.resourceValue
                            : "Enter Resource Value"
                        }
                      />
                      <InputField
                        name={`recurringCharges[${keyIndex}].resourceValue`}
                        className={"form-control"}
                        type="number"
                        handleChange={handleGrantsAndChargesResourceValueAndUsageFields(
                          handleChange
                        )}
                        value={
                          values?.recurringCharges?.[keyIndex]?.resourceValue
                        }
                        invalid={
                          errors.recurringCharges &&
                          errors.recurringCharges?.[keyIndex] &&
                          touched.recurringCharges &&
                          touched.recurringCharges?.[keyIndex] &&
                          touched.recurringCharges?.[keyIndex].resourceValue &&
                          errors.recurringCharges?.[keyIndex].resourceValue
                            ? true
                            : false
                        }
                      />
                    </Col>
                    <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                      <Label>Type of Resource</Label>
                      <LabelText
                        htmlFor={`recurringCharges[${keyIndex}].currency`}
                        classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                        displayText={"Currency"}
                      />
                      <InputField
                        name={`recurringCharges[${keyIndex}].currency`}
                        className={`${
                          isEdit ? "label-disable-color-edit-offer" : ""
                        }`}
                        value={"Currency"}
                        disabled
                      />
                    </Col>
                    {values?.recurringCharges?.[keyIndex]?.ceiling ? (
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`recurringCharges[${keyIndex}].ceiling`}>
                          Ceiling
                        </Label>
                        <LabelText
                          htmlFor={`charges[${keyIndex}].ceiling`}
                          classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                          displayText={"Enter Ceiling"}
                        />
                        <InputField
                          name={`charges[${keyIndex}].ceiling`}
                          className={`${
                            isEdit ? "label-disable-color-edit-offer" : ""
                          }`}
                          value={values?.recurringCharges?.[keyIndex]?.ceiling}
                          disabled
                        />
                      </Col>
                    ) : null}
                    {values?.recurringCharges?.[keyIndex]?.floor ? (
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`recurringCharges[${keyIndex}].floor`}>
                          Floor
                        </Label>
                        <LabelText
                          htmlFor={`charges[${keyIndex}].floor`}
                          classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                          displayText={"Enter Floor"}
                        />
                        <InputField
                          name={`charges[${keyIndex}].floor`}
                          className={`${
                            isEdit ? "label-disable-color-edit-offer" : ""
                          }`}
                          value={values?.recurringCharges?.[keyIndex]?.floor}
                          disabled
                        />
                      </Col>
                    ) : null}
                    {values?.recurringCharges?.[keyIndex]?.infinite && (
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`recurringCharges[${keyIndex}].infinite`}>
                          Infinite
                        </Label>
                        <LabelText
                          htmlFor={`charges[${keyIndex}].infinite`}
                          classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                          displayText={"Select Infinite"}
                        />

                        <SelectField
                          name={`recurringCharges[${keyIndex}].infinite`}
                          placeholder={" "}
                          value={values?.recurringCharges?.[keyIndex]?.infinite}
                          isDisabled={isSubscribed}
                          handleChange={handleInfiniteForGrantsAndCharges(
                            `recurringCharges[${keyIndex}].infinite`,
                            values?.recurringCharges?.[keyIndex],
                            setFieldValue
                          )}
                          options={infiniteOptions}
                          isRVStyle={true}
                        />
                      </Col>
                    )}
                    {values?.recurringCharges?.[keyIndex]?.type === "2" && (
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label>Prorate</Label>
                        <LabelText
                          htmlFor={`charges[${keyIndex}].prorate`}
                          classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                          displayText={"Enable / Disable Prorate"}
                        />
                        <FormGroup
                          switch
                          className="d-flex align-items-start switch-state"
                        >
                          <div className="me-2">
                            <Input
                              type="switch"
                              className="rv-form-switch-input"
                              disabled={isEdit}
                              checked={
                                values?.recurringCharges?.[keyIndex]?.prorate
                              }
                              onChange={() =>
                                handleChargesProrateState(
                                  keyIndex,
                                  values,
                                  setFieldValue
                                )
                              }
                            />
                          </div>
                          <div className="flex-column">
                            <LabelText
                              id={"UncontrolledTooltipExample"}
                              htmlFor={"globalOffer"}
                              className={"text-danger"}
                              displayText={"Prorate"}
                              check
                            />
                            <UncontrolledTooltip
                              target={"UncontrolledTooltipExample"}
                            >
                              Enable rating user based on their service
                              consumption
                            </UncontrolledTooltip>
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                    <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                      <Label>Override</Label>
                      <LabelText
                        htmlFor={`charges[${keyIndex}].override`}
                        classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                        displayText={"Enable / Disable Override"}
                      />
                      <FormGroup
                        switch
                        className="d-flex align-items-start switch-state"
                      >
                        <div className="me-2">
                          <Input
                            type="switch"
                            className="rv-form-switch-input"
                            disabled={isEdit}
                            checked={
                              values?.recurringCharges?.[keyIndex]?.override
                            }
                            onChange={() =>
                              handleChargesRecurringOverride(
                                keyIndex,
                                values,
                                setFieldValue
                              )
                            }
                          />
                        </div>
                        <div className="flex-column">
                          <LabelText
                            id={"UncontrolledTooltipExampleOverride"}
                            htmlFor={"globalOfferOverride"}
                            className={"text-danger"}
                            displayText={"Override"}
                            check
                          />
                          <UncontrolledTooltip
                            target={"UncontrolledTooltipExampleOverride"}
                          >
                            Enable overriding of resource value
                          </UncontrolledTooltip>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
        );
      }}
    </FieldArray>
  );
}
